import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useCallback } from 'react';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';
import { SidenavCollapsibleGroupItem } from '../Sidenav.CollapsibleGroup.Item/Sidenav.CollapsibleGroup.Item.es.js';

const SidenavCollapsibleGroup = ({ defaultCollapsedState = true, groupName, className, name, children, ...props })=>{
    const [isCollapsed, setIsCollapsed] = useState(defaultCollapsedState);
    const toggleCollapse = useCallback(()=>{
        setIsCollapsed(!isCollapsed);
    }, [
        setIsCollapsed,
        isCollapsed
    ]);
    return jsxs("div", {
        ...props,
        children: [
            jsx("div", {
                className: "cb-sidenav-collapsible-group",
                onClick: toggleCollapse,
                children: jsxs("span", {
                    className: "inner",
                    children: [
                        jsx(Icon, {
                            className: "item-icon",
                            name: name,
                            size: 20
                        }),
                        jsx("span", {
                            className: "label",
                            children: groupName
                        }),
                        jsx(Icon, {
                            className: classNames('icon', {
                                reverse: isCollapsed
                            }),
                            name: "ChevronUpSolid",
                            size: 20
                        })
                    ]
                })
            }),
            jsx("span", {
                className: classNames('cb-group-items', className, {
                    collapsed: isCollapsed
                }),
                "data-testid": "sidenav-collapsible-group-items",
                children: children
            })
        ]
    });
};
SidenavCollapsibleGroup.displayName = 'Sidenav.CollapsibleGroup';
SidenavCollapsibleGroup.Item = SidenavCollapsibleGroupItem;

export { SidenavCollapsibleGroup };
//# sourceMappingURL=Sidenav.CollapsibleGroup.es.js.map
